module.exports = __webpack_public_path__ + "img/handraw_adresse.0c65f6d1.svg";